// Shared gatekeeper token for public backend functions that trigger admin
// notifications. Read from the VITE_PUBLIC_FN_TOKEN build-time env secret (set
// via app secrets) so the value is not hardcoded in source. Must match the
// PUBLIC_FN_TOKEN server-side env var used by base44/shared/publicEndpointAuth.ts.
export const PUBLIC_FN_TOKEN = import.meta.env.VITE_PUBLIC_FN_TOKEN || '';